import { render, staticRenderFns } from "./CampaignsFiltersDropdowns.vue?vue&type=template&id=01248c34&scoped=true"
import script from "./CampaignsFiltersDropdowns.vue?vue&type=script&lang=ts"
export * from "./CampaignsFiltersDropdowns.vue?vue&type=script&lang=ts"
import style0 from "./CampaignsFiltersDropdowns.vue?vue&type=style&index=0&id=01248c34&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "01248c34",
  null
  
)

export default component.exports